import {React, styled} from 'common'
import {FormCheckbox} from './Form'
import {useI18n} from 'store/Store'
import {Link} from 'react-router-dom'

const ApproveTerms = ({control, checkboxProps}) => {
    const {i18n} = useI18n()
    return (
        <Container>
            <StyledFormCheckbox
                label={i18n.t('register.terms')}
                control={control}
                name="approveTerms"
                checkboxProps={checkboxProps}
            />
            <StyledLink
                to="https://www.familybiz.co.il/legal/terms-planner"
                target="_blank">
                {i18n.t('register.termsLink')}
            </StyledLink>
        </Container>
    )
}
export default ApproveTerms

const Container = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
`

const StyledFormCheckbox = styled(FormCheckbox)`
    width: 76px;
`

const StyledLink = styled(Link)`
    margin-bottom: 3px;
`
